document.addEventListener("DOMContentLoaded", () => {
  // 神秘盒：箱子底层进入视口 20% 时自动按顺序弹出，仅触发一次
  const stages = document.querySelectorAll("[data-mystery-stage]");
  // 每箱弹出间隔（毫秒），需与 CSS 动画时长匹配
  const BOX_REVEAL_INTERVAL = 400;
  // 箱子底层可见比例达到此值时触发
  const BOX_BOTTOM_VISIBLE_RATIO = 0.2;

  stages.forEach((stage) => {
    const boxBottom = stage.querySelector(".mystery-2026__box-bottom");
    if (!boxBottom) return;

    let revealed = false;

    // 按顺序弹出三箱：第3箱(9~12) → 第1箱(1~4) → 第2箱(5~8)
    function revealMysteryBoxes() {
      if (revealed) return;
      revealed = true;
      stage.setAttribute("data-revealed", "true");

      // 第3箱：产品 9~12
      stage.classList.add("is-revealed-box-3");

      window.setTimeout(() => {
        // 第1箱：产品 1~4
        stage.classList.add("is-revealed-box-1");
      }, BOX_REVEAL_INTERVAL);

      window.setTimeout(() => {
        // 第2箱：产品 5~8
        stage.classList.add("is-revealed-box-2");
      }, BOX_REVEAL_INTERVAL * 2);
    }

    // 减少动效偏好：三箱同时弹出
    function revealAllBoxes() {
      if (revealed) return;
      revealed = true;
      stage.setAttribute("data-revealed", "true");
      stage.classList.add("is-revealed-box-3", "is-revealed-box-1", "is-revealed-box-2");
    }

    const triggerReveal = window.matchMedia("(prefers-reduced-motion: reduce)").matches
      ? revealAllBoxes
      : revealMysteryBoxes;

    // 监听箱子底层进入视口 20% 时自动弹出
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && entry.intersectionRatio >= BOX_BOTTOM_VISIBLE_RATIO) {
            triggerReveal();
            observer.disconnect();
          }
        });
      },
      {
        threshold: BOX_BOTTOM_VISIBLE_RATIO,
      }
    );

    observer.observe(boxBottom);
  });
});
